import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createBatch } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useCreateBatch({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const queryclient = useQueryClient();

  const Request = useMutation({
    mutationFn: createBatch,
    mutationKey: ['createBatch'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries(['batchLists']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
